"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractWebsocketClientConnection = exports.CUSTOM_GOING_AWAY = exports.GOING_AWAY = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const Connection_1 = require("../Connection");
const IConnection_1 = require("../IConnection");
const utils_1 = require("@streamr/utils");
// https://kapeli.com/cheat_sheets/WebSocket_Status_Codes.docset/Contents/Resources/Documents/index
// Browsers send this automatically when closing a tab
exports.GOING_AWAY = 1001;
// The GOING_AWAY is a reserved code and we shouldn't send that from the application. Therefore
// we have a custom counterpart
exports.CUSTOM_GOING_AWAY = 3001;
// https://github.com/websockets/ws/blob/master/doc/ws.md#ready-state-constants
const OPEN = 1;
const logger = new utils_1.Logger(module);
class AbstractWebsocketClientConnection extends eventemitter3_1.default {
    connectionId;
    connectionType = IConnection_1.ConnectionType.WEBSOCKET_CLIENT;
    destroyed = false;
    constructor() {
        super();
        this.connectionId = (0, Connection_1.createRandomConnectionId)();
    }
    send(data) {
        if (!this.destroyed) {
            if (this.socket && this.socket.readyState === OPEN) {
                logger.trace(`Sending data with size ${data.byteLength}`);
                this.socket?.send(data);
            }
            else {
                // Could this throw for faster feedback on RPC calls?
                // Currently this log line is seen if a connection is closing but the disconnected event has not been emitted yet.
                logger.debug('Tried to send data on a non-open connection', {
                    id: this.connectionId,
                    readyState: this.socket.readyState,
                    destroyed: this.destroyed
                });
            }
        }
        else {
            logger.debug('Tried to send() on stopped connection');
        }
    }
    async close(gracefulLeave) {
        this.emit('disconnected', gracefulLeave, undefined, 'close() called');
        this.removeAllListeners();
        if (!this.destroyed) {
            logger.trace(`Closing socket for connection ${this.connectionId}`);
            this.socket?.close(gracefulLeave ? exports.CUSTOM_GOING_AWAY : undefined);
        }
        else {
            logger.debug('Tried to close() a stopped connection', { id: this.connectionId });
        }
    }
    destroy() {
        logger.trace('destroy() a connection');
        if (!this.destroyed) {
            this.removeAllListeners();
            if (this.socket) {
                this.stopListening();
                this.socket.close();
                this.socket = undefined;
            }
            this.destroyed = true;
        }
        else {
            logger.debug('Tried to destroy() a stopped connection');
        }
    }
    onOpen() {
        if (!this.destroyed) {
            logger.trace('WebSocket Client Connected');
            if (this.socket && this.socket.readyState === OPEN) {
                this.emit('connected');
            }
        }
    }
    onMessage(message) {
        this.emit('data', message);
    }
    onClose(code, reason) {
        if (!this.destroyed) {
            logger.trace('Websocket Closed');
            this.doDisconnect(code, reason);
        }
    }
    onError(error) {
        if (!this.destroyed) {
            logger.trace('WebSocket Client error: ' + error?.message, { error });
            this.emit('error', error.name);
        }
    }
    doDisconnect(code, reason) {
        this.destroyed = true;
        this.stopListening();
        this.socket = undefined;
        const gracefulLeave = (code === exports.GOING_AWAY) || (code === exports.CUSTOM_GOING_AWAY);
        this.emit('disconnected', gracefulLeave, code, reason);
        this.removeAllListeners();
    }
}
exports.AbstractWebsocketClientConnection = AbstractWebsocketClientConnection;
//# sourceMappingURL=AbstractWebsocketClientConnection.js.map